<template>
  <div class="flex flex-wrap gap-5 justify-center">
    <survey-answer-button
      v-for="answer in question.answers"
      :key="answer.value.toString()"
      @click="onPress(answer.value)"
    >
      <p class="font-content">
        {{ answer.label }}
      </p>
    </survey-answer-button>
  </div>
</template>

<script lang="ts" setup>
/**
 * Survey answer component for yes/no questions.
 */

import SurveyAnswerButton from '@/survey/components/survey-modal/answers/SurveyAnswerButton.vue';
import type {YesNoSurveyQuestion} from "@/core/interfaces/survey/Survey";
import type {
    SurveyAnswerComponentEmit,
    SurveyAnswerComponentProps
} from "@/survey/components/survey-modal/answers/index";


defineProps<SurveyAnswerComponentProps<YesNoSurveyQuestion>>();
const emits = defineEmits<SurveyAnswerComponentEmit<YesNoSurveyQuestion>>();

/**
 * Submit the selected answer
 */
const onPress = (value: boolean) => {
    emits('onPress', {value: [value]});
};
</script>
